document.addEventListener('DOMContentLoaded', function() {

    var initProductSliders = function() {
        var attachImage = function(img, containerSelector) {
            const container = img.closest(containerSelector) || img.parentNode;

            if (img.complete && img.naturalWidth > 0) {
                container.classList.add('image-loaded');
                return;
            }

            container.classList.add('image-loading');
            img.addEventListener('load', () => {
                container.classList.remove('image-loading');
                container.classList.add('image-loaded');
            });
            img.addEventListener('error', () => {
                container.classList.remove('image-loading');
                container.classList.add('image-load-error');
            });
        };
        var initSliders = function(sliders) {
            sliders.forEach(function (slider) {
                if (slider.childNodes.length > 0) {
                    var flickity = new Flickity(slider, {
                        // options
                        cellAlign: 'left',
                        contain: true,
                        adaptiveHeight: false,
                        autoPlay: false,
                        avoidReflow: false,
                        dragThreshold: 7,
                        fade: false,
                        friction: 0.8,
                        initialIndex: 0,
                        prevNextButtons: false,
                        pageDots: false,
                        selectedAttraction: 0.14,
                        setGallerySize: true,
                        wrapAround: true,
                        on: {
                            ready: function () {
                                slider.classList.add('is-ready');

                                // flickity forces click propagation, so we need to use custom buttons
                                var flkty = this,
                                    container = slider.closest('.grid-product__content'),
                                    btnPrev = container.querySelector('.grid-product__prev-btn'),
                                    btnNext = container.querySelector('.grid-product__next-btn');
                                btnPrev.addEventListener('click', (e) => {
                                    e.stopPropagation();
                                    e.stopImmediatePropagation();
                                    flkty.previous();
                                });
                                btnNext.addEventListener('click', (e) => {
                                    e.stopPropagation();
                                    e.stopImmediatePropagation();
                                    flkty.next();
                                });
                                this.on('select.flickity', function () {
                                    btnPrev.disabled = (flkty.selectedIndex === 0);
                                    btnNext.disabled = (flkty.selectedIndex === flkty.slides.length - 1);
                                });
                                window.addEventListener('resize', function () {
                                    flkty.resize();
                                });

                                let images = slider.querySelectorAll('.flickity-slider img.image-element');
                                if (images.length > 0) {
                                    images.forEach(img => {
                                        // add lazy loading classes
                                        attachImage(img, 'image-element');
                                        // force lazy loaded image opacity
                                        img.style.opacity = 1;
                                    });
                                }
                            },
                            scroll: function (progress) {
                                var flkty = this,
                                    container = slider.closest('.grid-product__content'),
                                    progressBarMeter = container.querySelector('.grid-product__progress-bar-meter');
                                container.querySelector('.grid-product__progress-bar').style.visibility = '';
                                container.querySelectorAll('.grid-product__prev-next-btn').forEach(function (gridProductButtons) {
                                    gridProductButtons.style.visibility = '';
                                });
                                if (flkty.slides.length > 0) {
                                    progress = Math.max(0, Math.min(1, progress));
                                    // dynamic width of the meter in %
                                    var meterWidthPerc = 100 / (flkty.slides.length);
                                    // available space
                                    var availablePerc = 100 - meterWidthPerc;
                                    // set meter position
                                    progressBarMeter.style.width = meterWidthPerc + '%';
                                    progressBarMeter.style.left = (meterWidthPerc * flkty.selectedIndex) + '%';
                                } else {
                                    // hide progress
                                    container.querySelector('.grid-product__progress-bar').style.visibility = 'hidden';
                                }
                                if (flkty.slides.length <= 1) {
                                    // hide prev/next buttons
                                    container.querySelectorAll('.grid-product__prev-next-btn').forEach(function (gridProductButtons) {
                                        gridProductButtons.style.visibility = 'hidden';
                                    });
                                }
                            }

                        }
                    });
                    slider.classList.add('is-initialized');
                }
            });
        };
        var slidersNotNested = document.querySelectorAll('.grid-product__slideshow:not(.grid-product__slideshow--nested):not(.is-initialized)');
        initSliders(slidersNotNested);

        // Hotfix for product recommendations
        var slidersNested = document.querySelectorAll('.grid-product__slideshow.grid-product__slideshow--nested:not(.is-initialized)');
        initSliders(slidersNested);
        const targetNode = document.querySelector('.product-recommendations-placeholder');
        const config = { childList: true, subtree: true };
        const callback = function(mutationsList, observer) {
            for(const mutation of mutationsList) {
                if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                    const slidersNested = targetNode.querySelectorAll('.grid-product__slideshow.grid-product__slideshow--nested:not(.is-initialized)');
                    if (slidersNested.length > 0) {
                        initSliders(slidersNested);
                    }
                    observer.disconnect();
                }
            }
        };
        const observer = new MutationObserver(callback);
        if (targetNode) {
            observer.observe(targetNode, config);
        }
    };

    initProductSliders();
    window.addEventListener('load', function(e) {
        initProductSliders();
    });
    document.addEventListener('grid-update', function(e) {
        initProductSliders();
    });

});